import React from 'react';

import { SVGComponentProps } from '../type';

const MessageIcon = (props: SVGComponentProps) => {
  const { width, height, fill, ...other } = props;

  return (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 15.207c-.46 0-.893-.234-1.2-.64l-1-1.334a.315.315 0 0 0-.133-.066h-.333c-2.78 0-4.5-.754-4.5-4.5V5.333c0-2.946 1.553-4.5 4.5-4.5h5.333c2.947 0 4.5 1.554 4.5 4.5v3.334c0 2.946-1.553 4.5-4.5 4.5h-.333c-.054 0-.1.026-.134.066l-1 1.334c-.306.406-.74.64-1.2.64zM5.333 1.833c-2.386 0-3.5 1.114-3.5 3.5v3.334c0 3.013 1.034 3.5 3.5 3.5h.334c.34 0 .727.193.933.466l1 1.334c.234.306.567.306.8 0l1-1.334a1.17 1.17 0 0 1 .934-.466h.333c2.386 0 3.5-1.114 3.5-3.5V5.333c0-2.386-1.114-3.5-3.5-3.5H5.334z"
        fill={fill}
      />
      <path
        d="M11.333 5.833H4.666a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5h6.667c.274 0 .5.227.5.5 0 .274-.226.5-.5.5zM8.666 9.167h-4a.504.504 0 0 1-.5-.5c0-.274.227-.5.5-.5h4c.274 0 .5.226.5.5 0 .273-.226.5-.5.5z"
        fill={fill}
      />
    </svg>
  );
};

MessageIcon.defaultProps = {
  width: 16,
  height: 16,
  fill: '#2563EB',
};

export { MessageIcon };
